var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeFeaturesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5542 183.482C65.4656 178.934 52.8595 170.68 43.0563 159.586C33.2531 148.492 26.6135 134.966 23.8332 120.424C21.0529 105.883 22.234 90.8616 27.253 76.9336C32.2719 63.0055 40.9439 50.6834 52.3606 41.2579C63.7773 31.8325 77.5186 25.6505 92.145 23.3597C106.771 21.0688 121.745 22.7533 135.497 28.2367C149.248 33.7201 161.273 42.8007 170.31 54.5272C179.347 66.2537 185.064 80.1947 186.863 94.8897",
    stroke: "white",
    strokeOpacity: 0.54,
    strokeWidth: 44.0294,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.739 32.0615C156.805 39.0229 167.758 49.3699 175.452 62.0185C183.145 74.6672 187.296 89.152 187.469 103.956C187.642 118.759 183.831 133.337 176.435 146.162C169.039 158.987 158.331 169.587 145.431 176.852C132.531 184.117 117.915 187.78 103.114 187.456C88.3129 187.132 73.8712 182.834 61.3015 175.012C48.7319 167.19 38.497 156.132 31.669 142.996C24.8409 129.86 21.6709 115.129 22.4911 100.347",
    stroke: "white",
    strokeWidth: 44.0294,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFeaturesLogo);
export default __webpack_public_path__ + "static/media/home_features_logo.c67f9a262c9637acd441da15c486b647.svg";
export { ForwardRef as ReactComponent };